import * as yup from "yup";
import { methods } from "./methods";

const YupSetup = () => {
  try {
    if (!Array.isArray(methods)) {
      console.error("Yup custom methods export is not an array.");
      return;
    }

    methods.forEach(({ name, register }) => {
      try {
        if (!name || typeof register !== "function") return;
        register(yup);
      } catch (e) {
        console.error(`Failed to register method: ${name}`, e);
      }
    });
  } catch (e) {
    console.error("Failed to setup yup custom methods.", e);
  }
};

export default YupSetup;
